import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from "@angular/core";
import { throwErrorMessage } from "../../../../helpers/kwikui.common.helpers";
import { DEFAULT_VALUES, VALIDATE_KEY_VALUES } from "./table.constants";
import { isValidKeyValue } from "./table.validation";

@Component({
  selector: "kwikui-table",
  templateUrl: "./table.component.html",
  styleUrls: ["./table.component.scss"]
})
export class KwikUITableComponent implements OnInit, OnChanges {
  @Input() columns: Array<any> = DEFAULT_VALUES.columns;

  @Input() data: Array<any> = DEFAULT_VALUES.data;

  @Input() headers: object = DEFAULT_VALUES.headers;

  @Input() id: string = DEFAULT_VALUES.id;

  @Output() onClick = new EventEmitter<any>();

  constructor() {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges) {
    for (const change of Object.entries(changes)) {
      const key: string = change[0];
      const value: any = change[1].currentValue;
      this.validateInputProperty(key, value);
    }
  }

  private validateInputProperty(key: string, value: any): void {
    if (VALIDATE_KEY_VALUES[key] && !isValidKeyValue(key, value)) {
      this[key] = DEFAULT_VALUES[key];
      throwErrorMessage(
        "kwikui-table",
        this.id,
        key,
        value,
        DEFAULT_VALUES[key]
      );
    }
  }

  handleOnClick(e: any): void {
    this.onClick.emit(e);
  }
}
